import { Appointment } from "types";
import {
  getDoctorImage,
  transformAppointmentStatus,
  transformAppointmentType,
  transformRelation,
} from "helpers";

const transformAppointment = (data: any): Appointment => {
  const {
    id,
    createdAt,
    start,
    end,
    status,
    appointmentType,
    comment,
    patient: { firstName, lastName, gender, relationshipToUser, birthday },
    practitioner: { id: doctorId, familyName, givenName, avatar },
    payment: { method, voucherTitle },
    communication,
  } = data;

  const doctor = {
    id: doctorId,
    firstName: givenName,
    lastName: familyName,
    displayName: `Dr. ${familyName}, ${givenName}`,
    image: avatar && getDoctorImage(doctorId, avatar),
  };

  const patient = {
    firstName,
    lastName,
    gender,
    birthday,
    relation: transformRelation(relationshipToUser),
    notes: comment,
  };

  return {
    id,
    type: transformAppointmentType(appointmentType),
    status: transformAppointmentStatus(status),
    createdAt,
    startAt: start,
    endAt: end,
    doctor,
    patient,
    payment: {
      method,
      voucher: voucherTitle,
    },
    call: communication && {
      token: communication.userToken,
      id: communication.callerDoctorID,
    },
  };
};

export { transformAppointment };
